import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { ValidationErrors } from '@angular/forms'
import { TrackingService } from '../tracking'

@Component({
  selector: 'app-lemonaid-primary-button',
  templateUrl: './lemonaid-primary-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LemonaidPrimaryButtonComponent {
  @Input() actionId: string
  @Input() actionContext: any[]
  @Input() additionalClass: string = ''
  @Input() dynamicClass: { [klass: string]: boolean } = {}
  @Input() styles: string = ''
  @Input() matIcon: string = ''
  @Input() disabled: boolean | ValidationErrors = false
  @Input() focusRegionStart = false

  constructor(private _trackingService: TrackingService) {}

  async trackButton() {
    const context = ''
    // if (this.actionContext && this.actionContext.length > 0) {
    //   for (const cntxt of this.actionContext) {
    //     context += JSON.stringify(cntxt)
    //   }
    // }
    this._trackingService.logAction(`${this.actionId} ${context}`)
  }
}
